import type { IOnlineCalculatorsApiState } from '@esprit/online-calculators';
import { onlineCalculatorsApiReducer } from '@esprit/online-calculators';
import type { RouterState } from 'connected-react-router';
import { connectRouter } from 'connected-react-router';
import type { History } from 'history';
import { combineReducers } from 'redux';
import type { FormStateMap } from 'redux-form';
import { reducer as formReducer } from 'redux-form';
import type { IApplicationState } from './application';
import { applicationReducer } from './application';
import type { IAppointmentsApiState } from './appointments-api/appointments-api-reducer';
import appointmentsApiReducer from './appointments-api/appointments-api-reducer';
import type { IChatApiState } from './chat-api/chat-api-reducer';
import { chatApiReducer } from './chat-api/chat-api-reducer';
import type { ICustomerBaseApiState } from './customer-base-api';
import { customerBaseApiReducer } from './customer-base-api';
import type { IPersonApiState } from './customer-master-data-api';
import { customerMasterDataApiReducer } from './customer-master-data-api';
import type { IEmployeeMasterDataState } from './employee-master-data-api';
import { employeeMasterDataReducer } from './employee-master-data-api';
import type { IFinnovaApiState } from './finnova-api';
import { finnovaApiReducer } from './finnova-api';
import type { IIamApiState } from './iam-api';
import { iamApiReducer } from './iam-api';
import type { INotificationsApiState } from './notifications-api/notifications-api-reducer';
import { notificationsApiReducer } from './notifications-api/notifications-api-reducer';
import type { IPortalAccountApiState } from './portal-account-api';
import { portalAccountApiReducer } from './portal-account-api';
import type { IProcessEngineApiState } from './process-engine-api';
import { processEngineApiReducer } from './process-engine-api';
import type { ISecureDocumentStoreApiState } from './secure-document-store-api/secure-document-store-api-reducer';
import secureDocumentStoreApiReducer from './secure-document-store-api/secure-document-store-api-reducer';
import type { ISecureInboxApiState } from './secure-inbox-api/secure-inbox-api-reducer';
import secureInboxApiReducer from './secure-inbox-api/secure-inbox-api-reducer';
import type { ISettingsApiState } from './settings-api/settings-api-reducer';
import { settingsApiReducer } from './settings-api/settings-api-reducer';
import type { IUserInfoApiState } from './user-info-api';
import { userInfoApiReducer } from './user-info-api';

interface IRootState {
    application: IApplicationState;
    portalAccountApi: IPortalAccountApiState;
    customerApi: IPersonApiState;
    userInfoApi: IUserInfoApiState;
    settingsApi: ISettingsApiState;
    appointmentsApi: IAppointmentsApiState;
    secureDocumentStoreApi: ISecureDocumentStoreApiState;
    secureInboxApi: ISecureInboxApiState;
    chatApi: IChatApiState;
    notificationsApi: INotificationsApiState;
    employeeMasterDataApi: IEmployeeMasterDataState;
    form: FormStateMap;
    router: RouterState;
    onlineCalculatorsApi: IOnlineCalculatorsApiState;
    customerBaseApi: ICustomerBaseApiState;
    processEngineApi: IProcessEngineApiState;
    finnovaApi: IFinnovaApiState;
    iam: IIamApiState;
}
export type { IRootState };

export const createRootReducer = (history: History) =>
    combineReducers<IRootState>({
        application: applicationReducer,
        userInfoApi: userInfoApiReducer,
        portalAccountApi: portalAccountApiReducer,
        customerApi: customerMasterDataApiReducer,
        appointmentsApi: appointmentsApiReducer,
        settingsApi: settingsApiReducer,
        secureInboxApi: secureInboxApiReducer,
        secureDocumentStoreApi: secureDocumentStoreApiReducer,
        chatApi: chatApiReducer,
        notificationsApi: notificationsApiReducer,
        employeeMasterDataApi: employeeMasterDataReducer,
        form: formReducer,
        onlineCalculatorsApi: onlineCalculatorsApiReducer,
        router: connectRouter(history),
        customerBaseApi: customerBaseApiReducer,
        processEngineApi: processEngineApiReducer,
        finnovaApi: finnovaApiReducer,
        iam: iamApiReducer,
    });
